// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1e08S","tab":"ProcedureTabs_tab__tNJHb"};